import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (u) => (u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

// URL-friendly slug for clean booking links (/book/<slug>); falls back to the
// show id when the name has no latin characters (e.g. Hindi-only titles)
export const showSlug = (s) => {
  const slug = (s?.name || "").toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return slug || s?.id || "";
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sumiran_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

// cachedGet: dedupes identical concurrent GETs and caches for 30s —
// several homepage components need the same data (gallery, settings) and should share one request.
const getCache = new Map();
export function cachedGet(path, ttlMs = 30000) {
  const now = Date.now();
  const hit = getCache.get(path);
  if (hit && (hit.promise || now - hit.time < ttlMs)) {
    return hit.promise || Promise.resolve({ data: hit.data });
  }
  const promise = api.get(path).then((res) => {
    getCache.set(path, { time: Date.now(), data: res.data });
    return res;
  }).catch((err) => {
    getCache.delete(path);
    throw err;
  });
  getCache.set(path, { promise });
  return promise;
}
